function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import React from 'react';
import PropTypes from 'prop-types';
import { maritalStatusName, educationStatusName, accommodationTypeName, employmentTypeName, carStatusName } from 'enums';
import { jsx as ___EmotionJSX } from "@emotion/react";
var container = {
  display: 'flex',
  flexDirection: 'column',
  gap: '2em'
};

var sectionHeader = function sectionHeader(theme) {
  return {
    display: 'flex',
    alignItems: 'center',
    gap: '0.6em',
    paddingBottom: '0.8em',
    borderBottom: "1px solid ".concat(theme.gray150),
    marginBottom: '1em',
    '& i': {
      fontSize: '1.6rem',
      color: theme.primary
    },
    '& span': {
      fontSize: '1.3rem',
      fontWeight: 600,
      color: theme.gray700,
      textTransform: 'uppercase',
      letterSpacing: '0.04em'
    }
  };
};

var grid = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
  gap: '1.2em 2em'
};

var fieldStyle = function fieldStyle(theme) {
  return {
    '& .field-label': {
      fontSize: '1.15rem',
      color: theme.gray400,
      marginBottom: '0.3em',
      fontWeight: 500
    },
    '& .field-value': {
      fontSize: '1.4rem',
      color: theme.gray800,
      fontWeight: 500,
      wordBreak: 'break-word'
    },
    '& .field-value.empty': {
      color: theme.gray300,
      fontStyle: 'italic'
    }
  };
};

var chipGrid = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
  gap: '0.8em'
};

var chipStyle = function chipStyle(isYes) {
  return function (theme) {
    return {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0.6em 1em',
      backgroundColor: isYes ? theme.successLight : theme.gray50,
      border: "1px solid ".concat(isYes ? theme.success : theme.gray150),
      fontSize: '1.2rem',
      '& .chip-label': {
        color: theme.gray700
      },
      '& .chip-value': {
        fontWeight: 600,
        color: isYes ? theme.success : theme.gray400,
        fontSize: '1.1rem'
      }
    };
  };
};

var phoneChip = function phoneChip(theme) {
  return {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.5em',
    padding: '0.4em 1em',
    backgroundColor: theme.gray50,
    border: "1px solid ".concat(theme.gray150),
    fontSize: '1.3rem',
    color: theme.gray800,
    fontWeight: 500,
    marginRight: '0.6em',
    marginBottom: '0.4em',
    '& i': {
      fontSize: '1.3rem',
      color: theme.primary
    }
  };
};

var Field = function Field(_ref) {
  var label = _ref.label,
      value = _ref.value;
  return ___EmotionJSX("div", {
    css: fieldStyle
  }, ___EmotionJSX("p", {
    className: "field-label"
  }, label), ___EmotionJSX("p", {
    className: "field-value".concat(!value ? ' empty' : '')
  }, value || '—'));
};

Field.propTypes = {
  label: PropTypes.string,
  value: PropTypes.any
};

var BoolChip = function BoolChip(_ref2) {
  var label = _ref2.label,
      value = _ref2.value;
  return ___EmotionJSX("div", {
    css: chipStyle(!!value)
  }, ___EmotionJSX("span", {
    className: "chip-label"
  }, label), ___EmotionJSX("span", {
    className: "chip-value"
  }, value ? 'Да' : 'Не'));
};

BoolChip.propTypes = {
  label: PropTypes.string,
  value: PropTypes.any
};

var Section = function Section(_ref3) {
  var icon = _ref3.icon,
      title = _ref3.title,
      children = _ref3.children;
  return ___EmotionJSX("div", null, ___EmotionJSX("div", {
    css: sectionHeader
  }, ___EmotionJSX("i", {
    className: icon
  }), ___EmotionJSX("span", null, title)), children);
};

Section.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.node
};

var fullName = function fullName(data) {
  return [data === null || data === void 0 ? void 0 : data.first_name, data === null || data === void 0 ? void 0 : data.middle_name, data === null || data === void 0 ? void 0 : data.last_name].filter(Boolean).join(' ');
};

var formatCity = function formatCity(city) {
  var _city$type, _city$name;

  return city ? "".concat((_city$type = city === null || city === void 0 ? void 0 : city.type) !== null && _city$type !== void 0 ? _city$type : '', " ").concat((_city$name = city === null || city === void 0 ? void 0 : city.name) !== null && _city$name !== void 0 ? _city$name : '').trim() : null;
};

var BorrowerData = function BorrowerData(_ref4) {
  var _data$phones, _data$id_card_area, _data$id_card_municip, _data$current_area, _data$current_municip;

  var data = _ref4.data;
  return ___EmotionJSX("div", {
    style: container
  }, ___EmotionJSX(Section, {
    icon: "las la-user",
    title: "\u041B\u0438\u0447\u043D\u0438 \u0434\u0430\u043D\u043D\u0438"
  }, ___EmotionJSX("div", {
    style: grid
  }, ___EmotionJSX(Field, {
    label: "\u0418\u043C\u0435",
    value: fullName(data)
  }), ___EmotionJSX(Field, {
    label: "\u0415\u0413\u041D",
    value: data === null || data === void 0 ? void 0 : data.id_number
  }), ___EmotionJSX(Field, {
    label: "\u0418\u043C\u0435\u0439\u043B",
    value: data === null || data === void 0 ? void 0 : data.email
  })), (data === null || data === void 0 ? void 0 : (_data$phones = data.phones) === null || _data$phones === void 0 ? void 0 : _data$phones.length) > 0 && ___EmotionJSX("div", {
    style: {
      marginTop: '1em'
    }
  }, ___EmotionJSX("p", {
    css: function css(theme) {
      return {
        fontSize: '1.15rem',
        color: theme.gray400,
        fontWeight: 500,
        marginBottom: '0.5em'
      };
    }
  }, "\u0422\u0435\u043B\u0435\u0444\u043E\u043D\u0438"), ___EmotionJSX("div", {
    style: {
      display: 'flex',
      flexWrap: 'wrap'
    }
  }, data.phones.map(function (el) {
    return ___EmotionJSX("span", {
      css: phoneChip,
      key: el
    }, ___EmotionJSX("i", {
      className: "las la-phone"
    }), el);
  })))), ___EmotionJSX(Section, {
    icon: "las la-id-card",
    title: "\u041B\u0438\u0447\u043D\u0430 \u043A\u0430\u0440\u0442\u0430"
  }, ___EmotionJSX("div", {
    style: grid
  }, ___EmotionJSX(Field, {
    label: "\u041D\u043E\u043C\u0435\u0440",
    value: data === null || data === void 0 ? void 0 : data.id_card_number
  }), ___EmotionJSX(Field, {
    label: "\u0418\u0437\u0434\u0430\u0434\u0435\u043D\u0430 \u043D\u0430",
    value: data === null || data === void 0 ? void 0 : data.id_card_issued_date
  }), ___EmotionJSX(Field, {
    label: "\u0412\u0430\u043B\u0438\u0434\u043D\u0430 \u0434\u043E",
    value: data === null || data === void 0 ? void 0 : data.id_card_valid_to_date
  }), ___EmotionJSX(Field, {
    label: "\u0418\u0437\u0434\u0430\u0434\u0435\u043D\u0430 \u043E\u0442",
    value: data === null || data === void 0 ? void 0 : data.id_card_issued_from
  }))), ___EmotionJSX(Section, {
    icon: "las la-map-marker-alt",
    title: "\u0410\u0434\u0440\u0435\u0441 \u043F\u043E \u043B\u0438\u0447\u043D\u0430 \u043A\u0430\u0440\u0442\u0430"
  }, ___EmotionJSX("div", {
    style: grid
  }, ___EmotionJSX(Field, {
    label: "\u041E\u0431\u043B\u0430\u0441\u0442",
    value: data === null || data === void 0 ? void 0 : (_data$id_card_area = data.id_card_area) === null || _data$id_card_area === void 0 ? void 0 : _data$id_card_area.name
  }), ___EmotionJSX(Field, {
    label: "\u041E\u0431\u0449\u0438\u043D\u0430",
    value: data === null || data === void 0 ? void 0 : (_data$id_card_municip = data.id_card_municipality) === null || _data$id_card_municip === void 0 ? void 0 : _data$id_card_municip.name
  }), ___EmotionJSX(Field, {
    label: "\u0413\u0440\u0430\u0434/\u0441\u0435\u043B\u043E",
    value: formatCity(data === null || data === void 0 ? void 0 : data.id_card_city)
  }), ___EmotionJSX(Field, {
    label: "\u041A\u0432\u0430\u0440\u0442\u0430\u043B",
    value: data === null || data === void 0 ? void 0 : data.id_card_quarter
  }), ___EmotionJSX(Field, {
    label: "\u0410\u0434\u0440\u0435\u0441",
    value: data === null || data === void 0 ? void 0 : data.id_card_address
  }))), ___EmotionJSX(Section, {
    icon: "las la-home",
    title: "\u041D\u0430\u0441\u0442\u043E\u044F\u0449 \u0430\u0434\u0440\u0435\u0441"
  }, ___EmotionJSX("div", {
    style: grid
  }, ___EmotionJSX(Field, {
    label: "\u041E\u0431\u043B\u0430\u0441\u0442",
    value: data === null || data === void 0 ? void 0 : (_data$current_area = data.current_area) === null || _data$current_area === void 0 ? void 0 : _data$current_area.name
  }), ___EmotionJSX(Field, {
    label: "\u041E\u0431\u0449\u0438\u043D\u0430",
    value: data === null || data === void 0 ? void 0 : (_data$current_municip = data.current_municipality) === null || _data$current_municip === void 0 ? void 0 : _data$current_municip.name
  }), ___EmotionJSX(Field, {
    label: "\u0413\u0440\u0430\u0434/\u0441\u0435\u043B\u043E",
    value: formatCity(data === null || data === void 0 ? void 0 : data.current_city)
  }), ___EmotionJSX(Field, {
    label: "\u041A\u0432\u0430\u0440\u0442\u0430\u043B",
    value: data === null || data === void 0 ? void 0 : data.current_quarter
  }), ___EmotionJSX(Field, {
    label: "\u0410\u0434\u0440\u0435\u0441",
    value: data === null || data === void 0 ? void 0 : data.current_address
  }))), ___EmotionJSX(Section, {
    icon: "las la-clipboard-list",
    title: "\u0414\u043E\u043F\u044A\u043B\u043D\u0438\u0442\u0435\u043B\u043D\u0438 \u0434\u0430\u043D\u043D\u0438"
  }, ___EmotionJSX("div", {
    style: grid
  }, ___EmotionJSX(Field, {
    label: "\u0421\u0435\u043C\u0435\u0439\u043D\u043E \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435",
    value: maritalStatusName[data === null || data === void 0 ? void 0 : data.marital_status]
  }), ___EmotionJSX(Field, {
    label: "\u041E\u0431\u0440\u0430\u0437\u043E\u0432\u0430\u043D\u0438\u0435",
    value: educationStatusName[data === null || data === void 0 ? void 0 : data.education]
  }), ___EmotionJSX(Field, {
    label: "\u0422\u0440\u0443\u0434\u043E\u0432\u043E \u043F\u0440\u0430\u0432\u043E\u043E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u0435",
    value: employmentTypeName[data === null || data === void 0 ? void 0 : data.employment]
  }), ___EmotionJSX(Field, {
    label: "\u0422\u0438\u043F \u043D\u0430\u0441\u0442\u0430\u043D\u044F\u0432\u0430\u043D\u0435",
    value: accommodationTypeName[data === null || data === void 0 ? void 0 : data.accommodation_type]
  }), ___EmotionJSX(Field, {
    label: "\u0410\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B",
    value: carStatusName[data === null || data === void 0 ? void 0 : data.car_ownership]
  })), ___EmotionJSX("div", {
    style: _objectSpread(_objectSpread({}, chipGrid), {}, {
      marginTop: '1.4em'
    })
  }, ___EmotionJSX(BoolChip, {
    label: "\u0414\u0440\u0443\u0433\u043E \u0433\u0440\u0430\u0436\u0434\u0430\u043D\u0441\u0442\u0432\u043E",
    value: data === null || data === void 0 ? void 0 : data.other_citizenship
  }), ___EmotionJSX(BoolChip, {
    label: "\u041F\u043E\u043B\u0438\u0442\u0438\u0447\u0435\u0441\u043A\u0430 \u043B\u0438\u0447\u043D\u043E\u0441\u0442",
    value: data === null || data === void 0 ? void 0 : data.political_figure
  }), ___EmotionJSX(BoolChip, {
    label: "\u041E\u0444\u0438\u0446\u0438\u0430\u043B\u0435\u043D \u0434\u043E\u0445\u043E\u0434",
    value: data === null || data === void 0 ? void 0 : data.has_official_income
  }), ___EmotionJSX(BoolChip, {
    label: "\u0414\u043E\u0445\u043E\u0434 \u043D\u0430\u0434 1500 \u043B\u0432",
    value: data === null || data === void 0 ? void 0 : data.has_income_above_average_salary
  }), ___EmotionJSX(BoolChip, {
    label: "\u0421\u0442\u0430\u0436 \u043D\u0430\u0434 6 \u043C\u0435\u0441\u0435\u0446\u0430",
    value: data === null || data === void 0 ? void 0 : data.has_current_work_experience_more_than_6
  }), ___EmotionJSX(BoolChip, {
    label: "5+ \u043A\u0440\u0435\u0434\u0438\u0442\u0430",
    value: data === null || data === void 0 ? void 0 : data.has_more_than_5_loans
  }), ___EmotionJSX(BoolChip, {
    label: "\u0417\u0430\u0431\u0430\u0432\u0438 \u043D\u0430\u0434 30 \u0434\u043D\u0438",
    value: data === null || data === void 0 ? void 0 : data.has_loan_payment_delays_more_than_30_days
  }), ___EmotionJSX(BoolChip, {
    label: "\u041F\u0435\u043D\u0441\u0438\u043E\u043D\u0435\u0440",
    value: data === null || data === void 0 ? void 0 : data.is_retired
  }))));
};

BorrowerData.propTypes = {
  data: PropTypes.object
};
export default BorrowerData;